import React, { useEffect, useState } from 'react';
import Wrapper from './Wrapper';
import styles from './BillingPayment.module.scss';
import cx from 'classnames';
import { Form } from 'react-bootstrap';
import { BigButton } from '../../common';
import { PLAN_TYPE_LABEL, RECURRING_INTERVAL } from './subscriptionHelper';
import PlanBreadcrumb from './PlanBreadcrumb';
import PaymentMethods from './PaymentMethods';
import { convertStripeCentsToAmount } from './subscriptionHelper';
import BillingForm from './BillingForm';
import PlanDetails from './PlanDetails';
import { getLocalStorage, objectToFormData, removeLocalStorage } from '../../helpers/jsHelper';
import { SELECTED_PLAN } from '../../constants/projectConstants';
import { apiUpdateUserDetails } from '../../helpers/api';
import { useUserContext } from '../../contexts/UserContext';
import { selectUserActivePlanDetails } from '../../redux/slicers/subscriptionSlicer';
import { useSelector } from 'react-redux';
import { dispatcher } from '../../helpers/projectHelper';
import { GetAllCard } from '../../api/subscription/subscription';

function BillingPayment({
  loading,
  back,
  planDetails,
  handleUpgradePlan,
  // reviewPlan,
  downgrade,
  interval,
  isTexturePlan,
  recurringInterval = RECURRING_INTERVAL.MONTH,
  initialFlag,
}) {
  const activePlan = useSelector(selectUserActivePlanDetails);
  const { currentUser } = useUserContext();
  const [billCycle, setBillCycle] = useState(
    recurringInterval ? recurringInterval : initialFlag?.interval
  );

  const hideOtherOption = !downgrade && activePlan?.is_active_main_subscription_plan;

  useEffect(() => {
    dispatcher(GetAllCard());
    if (isTexturePlan !== null && interval !== null) {
      setBillCycle(interval);
    }

    return () => {
      const selectedPlan = getLocalStorage(SELECTED_PLAN, true);
      if (selectedPlan) {
        removeLocalStorage(SELECTED_PLAN);
        const payload = {
          other_info: JSON.stringify({
            ...currentUser?.user?.other_info,
            selectedPlan: '',
          }),
        };
        const formData = objectToFormData(payload);
        apiUpdateUserDetails(formData);
      }
    };
  }, []);

  const getPriceDetail = (list, interval, intervalCount) => {
    return list?.pricing_details?.find(
      ({ recurring_interval, recurring_interval_count }) => +recurring_interval === interval && recurring_interval_count?.toString() == intervalCount?.toString()
    )
  }

  const month = convertStripeCentsToAmount(
    planDetails?.pricing_details?.find(
      ({ recurring_interval, recurring_interval_count }) => +recurring_interval === +RECURRING_INTERVAL.MONTH && recurring_interval_count?.toString() === "1"
    )?.unit_amount || 0
  );

  const quarter = convertStripeCentsToAmount(
    planDetails?.pricing_details?.find(
      ({ recurring_interval, recurring_interval_count }) => +recurring_interval === +RECURRING_INTERVAL.MONTH && recurring_interval_count?.toString() === "3"
    )?.unit_amount || 0
  );

  const semiAnnually = convertStripeCentsToAmount(
    planDetails?.pricing_details?.find(
      ({ recurring_interval, recurring_interval_count }) => +recurring_interval === +RECURRING_INTERVAL.MONTH && recurring_interval_count?.toString() === "6"
    )?.unit_amount || 0
  );

  const year = convertStripeCentsToAmount(
    planDetails?.pricing_details?.find(
      ({ recurring_interval, recurring_interval_count }) => +recurring_interval === +RECURRING_INTERVAL.YEAR && recurring_interval_count?.toString() === "1"
    )?.unit_amount || 0
  );

  const goBack = () => {
    back && back();
  };

  const handleFeatureList = (filterBy = null, filterByValue = false) => {
    let list =
      billCycle === RECURRING_INTERVAL.MONTH
        ? getPriceDetail(planDetails, RECURRING_INTERVAL.MONTH, 1)?.feature_details || []
        : billCycle && billCycle === RECURRING_INTERVAL.YEAR
          ? getPriceDetail(planDetails, RECURRING_INTERVAL.YEAR, 1)?.feature_details || []
          :
          billCycle && billCycle === RECURRING_INTERVAL.QUARTER
            ? getPriceDetail(planDetails, RECURRING_INTERVAL.MONTH, 3)?.feature_details || []
            : billCycle && billCycle === RECURRING_INTERVAL.SEMI_ANNUALLY
              ? getPriceDetail(planDetails, RECURRING_INTERVAL.MONTH, 6)?.feature_details || []
              : []


    if (filterBy) {
      list = list.filter((a) => a[filterBy] === filterByValue);
    }
    list = handleFilterFeature(list);
    return list || [];
  };

  const handleFilterFeature = (features) => {
    if (features && features?.length > 0) {
      let filterList = [];
      if (isTexturePlan) {
        filterList = features?.filter(
          ({ type }) =>
            type?.toUpperCase() === PLAN_TYPE_LABEL.BOTH ||
            type?.toUpperCase() === PLAN_TYPE_LABEL.TEXTURE
        );
      } else {
        filterList = features?.filter(
          ({ type }) =>
            !type ||
            type?.toUpperCase() === PLAN_TYPE_LABEL.BOTH ||
            type?.toUpperCase() === PLAN_TYPE_LABEL.PRODUCT
        );
      }
      return filterList || [];
    } else {
      return [];
    }
  };

  const handleShowPlanPrice = () => {
    return (
      <div className="d-flex justify-content-between">
        {billCycle === RECURRING_INTERVAL.MONTH ? (
          <>
            <span className={styles.mutedText}>
              {' '}
              Imagine.io {planDetails?.name || 'N/A'} (Monthly)
            </span>
            <span className={styles.mutedText}>
              $
              {convertStripeCentsToAmount(
                getPriceDetail(planDetails, RECURRING_INTERVAL.MONTH, 1)?.unit_amount || 0
              )}{' '}
              USD
            </span>
          </>
        ) : billCycle === RECURRING_INTERVAL.QUARTER 
        ? (
          <>
            <span className={styles.mutedText}>
              {' '}
              Imagine.io {planDetails?.name || 'N/A'} (Quarterly)
            </span>
            <span className={styles.mutedText}>
              $
              {convertStripeCentsToAmount(
                getPriceDetail(planDetails, RECURRING_INTERVAL.MONTH, 3)?.unit_amount || 0
              )}{' '}
              USD
            </span>
          </>
        )
        :billCycle === RECURRING_INTERVAL.SEMI_ANNUALLY 
        ? (
            <>
              <span className={styles.mutedText}>
                {' '}
                Imagine.io {planDetails?.name || 'N/A'} (Semi-annually)
              </span>
              <span className={styles.mutedText}>
                $
                {convertStripeCentsToAmount(
                  getPriceDetail(planDetails, RECURRING_INTERVAL.MONTH, 6)?.unit_amount || 0
                )}{' '}
                USD
              </span>
            </>
          )
        : (
          <>
            <span className={styles.mutedText}>
              {' '}
              Imagine.io {planDetails?.name || 'N/A'} (Yearly)
            </span>
            <span className={styles.mutedText}>
              $
              {convertStripeCentsToAmount(
                getPriceDetail(planDetails, RECURRING_INTERVAL.YEAR, 1)?.unit_amount || 0
              )}{' '}
              USD
            </span>
          </>
        )}
      </div>
    );
  };

  const handleTotalPrice = () => {
    if (billCycle === RECURRING_INTERVAL.MONTH) {
      return `${convertStripeCentsToAmount(
        getPriceDetail(planDetails, RECURRING_INTERVAL.MONTH, 1)?.unit_amount || 0
      )}
      USD`;
    } else if (billCycle === RECURRING_INTERVAL.QUARTER) {
      return `${convertStripeCentsToAmount(
        getPriceDetail(planDetails, RECURRING_INTERVAL.MONTH, 3)?.unit_amount || 0
      )}
      USD`;
    }
    else if (billCycle === RECURRING_INTERVAL.SEMI_ANNUALLY){
      return `${convertStripeCentsToAmount(
        getPriceDetail(planDetails, RECURRING_INTERVAL.MONTH, 6)?.unit_amount || 0
      )}
      USD`;
    }
    else {
      return `${convertStripeCentsToAmount(
        getPriceDetail(planDetails, RECURRING_INTERVAL.YEAR, 1)?.unit_amount || 0
      )}
      USD`;
    }
  };

  const isBillingMonthlyChecked = billCycle === RECURRING_INTERVAL.MONTH;
  const isBillingYearlyChecked = billCycle === RECURRING_INTERVAL.YEAR;
  const isBillingQuarterlyChecked = billCycle === RECURRING_INTERVAL.QUARTER;
  const isBillingSemiAnnuallyChecked = billCycle === RECURRING_INTERVAL.SEMI_ANNUALLY;

  return (
    <>
      {planDetails && !downgrade ? (
        <>
          <PlanBreadcrumb goBack={goBack} />
        </>
      ) : (
        <>
          <PlanBreadcrumb
            goBack={goBack}
            {...(downgrade && {
              message: `By downgrading to ${planDetails?.name}, you’ll be losing access to crucial features.`,
            })}
          />
        </>
      )}

      <div className={cx('d-flex flex-row gap-4', styles.formWrapper)}>
        <div className={styles.billingInfoWrapper}>
          <Wrapper className={cx('p-4', styles.mainWrapper, styles.billingInfo)}>
            <div className="d-flex flex-column w-100">
              <h6>Billing cycle</h6>
              <p className={styles.mutedText}>
                Choose how often you’d like to be billed. You can cancel anytime.
              </p>
            </div>
            <Wrapper className="w-100">
              <Form>
                <div key={`inline-radio`} className="d-flex flex-column">
                  {hideOtherOption && billCycle !== RECURRING_INTERVAL.MONTH ? (
                    ''
                  ) : (
                    month ? <div
                      style={{ cursor: 'pointer' }}
                      onClick={() =>
                        billCycle !== RECURRING_INTERVAL.MONTH &&
                        setBillCycle(RECURRING_INTERVAL.MONTH)
                      }>
                      <Form.Check
                        type="radio"
                        className={cx(
                          styles.formCheck,
                          isBillingMonthlyChecked && styles.checked,
                          'mb-0'
                        )}>
                        <Form.Check.Input
                          type="radio"
                          name="group"
                          checked={isBillingMonthlyChecked}
                          onChange={(e) => e}
                        />
                        <Form.Check.Label>
                          <h6 className="mb-1">Monthly</h6>
                          <p className={styles.mutedText}>{`$${month} / month`}</p>
                        </Form.Check.Label>
                      </Form.Check>
                    </div>: null
                  )}

                  {hideOtherOption && billCycle !== RECURRING_INTERVAL.QUARTER ? (
                    ''
                  ) : (
                    quarter ? <div
                      style={{ cursor: 'pointer' }}
                      onClick={() =>
                        billCycle !== RECURRING_INTERVAL.QUARTER &&
                        setBillCycle(RECURRING_INTERVAL.QUARTER)
                      }>
                      <Form.Check
                        type="radio"
                        className={cx(
                          styles.formCheck,
                          isBillingQuarterlyChecked && styles.checked,
                          'mb-0'
                        )}>
                        <Form.Check.Input
                          type="radio"
                          name="group"
                          checked={isBillingQuarterlyChecked}
                          onChange={(e) => e}
                        />
                        <Form.Check.Label>
                          <h6 className="mb-1">Quarterly</h6>
                          <p className={styles.mutedText}>{`$${quarter} / quarterly`}</p>
                        </Form.Check.Label>
                      </Form.Check>
                    </div> :null
                  )}

                  {hideOtherOption && billCycle !== RECURRING_INTERVAL.SEMI_ANNUALLY ? (
                    ''
                  ) : (
                   semiAnnually? <div
                      style={{ cursor: 'pointer' }}
                      onClick={() =>
                        billCycle !== RECURRING_INTERVAL.SEMI_ANNUALLY &&
                        setBillCycle(RECURRING_INTERVAL.SEMI_ANNUALLY)
                      }>
                      <Form.Check
                        type="radio"
                        className={cx(
                          styles.formCheck,
                          isBillingSemiAnnuallyChecked && styles.checked,
                          'mb-0'
                        )}>
                        <Form.Check.Input
                          type="radio"
                          name="group"
                          checked={isBillingSemiAnnuallyChecked}
                          onChange={(e) => e}
                        />
                        <Form.Check.Label>
                          <h6 className="mb-1">Semi annually</h6>
                          <p className={styles.mutedText}>{`$${semiAnnually} / semi annually`}</p>
                        </Form.Check.Label>
                      </Form.Check>
                    </div> : null
                  )}

                  {hideOtherOption && billCycle !== RECURRING_INTERVAL.YEAR ? (
                    ''
                  ) : (
                    year ?  <div
                      style={{ cursor: 'pointer' }}
                      onClick={() =>
                        billCycle !== RECURRING_INTERVAL.YEAR &&
                        setBillCycle(RECURRING_INTERVAL.YEAR)
                      }>
                      <Form.Check
                        type="radio"
                        className={cx(
                          styles.formCheck,
                          isBillingYearlyChecked && styles.checked,
                          'mb-0'
                        )}>
                        <Form.Check.Input
                          type="radio"
                          name="group"
                          onChange={(e) => e}
                          checked={isBillingYearlyChecked}
                        />
                        <Form.Check.Label>
                          <div className="d-flex mb-1">
                            <h6 className="mb-1">Yearly</h6>
                            <BigButton className={styles.primaryTag} disabled>
                              RECOMMENDED
                            </BigButton>
                          </div>
                          <p className={styles.mutedText}>
                            {`$${year} / year`}
                            {/* {`$${year} / 12 = $${(+year / 12).toFixed(2)} / month`} */}
                          </p>
                        </Form.Check.Label>
                      </Form.Check>
                    </div> : null 
                  )}
                </div>
              </Form>
            </Wrapper>
          </Wrapper>
          <Wrapper>
            <BillingForm />
          </Wrapper>
          <PaymentMethods />
        </div>
        <Wrapper className={cx('p-4', styles.mainWrapper, styles.planInfo)}>
          <div className="d-flex flex-column w-100">
            <div className={cx('d-flex flex-column', styles.infoWrapper)}>
              <h5>{planDetails?.name || 'N/A'}</h5>
              <p>This is the key information about your subscription.</p>
            </div>

            <div className={styles.divider}></div>

            <PlanDetails
              title={'Plan Includes'}
              features={handleFeatureList('is_free_bee', false)}
              separatorTitle={
                <>
                  Freebies{' '}
                  <small>
                    <em>(*for first year only)</em>
                  </small>
                </>
              }
              features2={handleFeatureList('is_free_bee', true)}
              titleSectionStyle={{
                paddingLeft: 0,
                paddingRight: 0,
                borderTop: 'none',
                borderLeft: 'none',
                borderRight: 'none',
              }}
              makeTitleBold={true}
              pointsClassName={'px-0'}
              keepDetailsOpen={true}
              hideActions={true}
            />
            <div className={styles.divider}></div>
            <div className={cx('d-flex flex-column pt-2', styles.infoWrapper)}>
              {handleShowPlanPrice()}
            </div>
            <div className={styles.divider}></div>
            <div className="d-flex flex-column gap-4">
              <div className="d-flex justify-content-between">
                <h6 className="m-0">Total</h6>
                <h6 className="m-0">${handleTotalPrice()}</h6>
              </div>
              <BigButton
                disabled={loading}
                isLoading={loading}
                onClick={() => handleUpgradePlan(planDetails, billCycle)}
                className={styles.paymentButton}>
                Continue with payment
              </BigButton>
            </div>
          </div>
        </Wrapper>
      </div>
    </>
  );
}

export default BillingPayment;
